import { jsx as _jsx } from "react/jsx-runtime";
import styles from './styles.module.scss';
import { LabelS } from '../typography/typography';
export var Label = function (_a) {
    var children = _a.children, disabled = _a.disabled;
    return (_jsx(LabelS, { className: styles.label, color: disabled ? 'disabled' : 'secondary', children: children }));
};
